import {
  Box, Button, Heading, HStack, Spacer, useDisclosure, Table, Thead, Tr, Th, Tbody, Td, TableContainer, Stack, useToast, Skeleton, Image, InputGroup, Input, InputRightElement,
  UnorderedList,
  ListItem,
} from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import * as XLSX from 'xlsx'
import axios from 'axios';
import useUserStore from '../../Hooks/Zustand/Store';
import BackButtons from '../../Components/Buttons/BackButtons';
import CardFile from '../../Components/Accounting/CardFile';
import DynamicButton from '../../Components/Buttons/DynamicButton';
import { addDocumentFirebase } from '../../Api/firebaseApi';

function BulkProduct() {
  const globalState = useUserStore();
  const [file, setFile] = useState(null)
  const [transaction, setTransaction] = useState([])
  const [data, setData] = useState([]);
  const toast = useToast()

  const onSelectFile = (arg) => {
    setFile(arg)
  }

  // const fixedData = [];
  // const fixedArray = async (data) => {
  //   await Promise.all(data.map(async (x) => {
  //     if (x['NO.'] !== 0) {
  //       const dataOrder = {
  //         message: x['ID Pesanan'],
  //         amount: x['Total'],
  //         contact_information: {
  //           name: x['Nama Penerima'] || '',
  //           email: x['Email Penerima'] || '',
  //           address: x['Alamat Penerima'],
  //           phone_number: x['No.HP Penerima'] || ''
  //         },
  //         items: [
  //           {
  //             quantity: x['Jumlah'],
  //             shipping_status: '',
  //             shipping_provider: {
  //               description: '',
  //               from: '',
  //               note: '',
  //               provider: '',
  //               service: '',
  //               to: '',
  //               value: ''
  //             },
  //             images: [],
  //             name: x['Nama Produk'],
  //             delivery: {},
  //             price: x['Harga Awal Produk'],
  //             locations: x['Nama Gudang'],
  //             variant_skuId: x['SKU'] || '',
  //             variant: x['Variant Produk']
  //           }
  //         ],
  //         paymentStatus: x['Status'],
  //         paymentService: x['Pembayaran'],
  //         paymentGateway:'',
  //         userType:'costumer'
  //       };
  //       fixedData.push(dataOrder);
  //     } else {
  //       console.log('ini yang gaada no.');
  //       if (fixedData.length > 0) {
  //         const index = fixedData.length - 1;
  //         const newItem = {
  //           quantity: x['Jumlah'],
  //           shipping_status: '',
  //           shipping_provider: {
  //             description: '',
  //             from: '',
  //             note: '',
  //             provider: '',
  //             service: '',
  //             to: '',
  //             value: ''
  //           },
  //           images: x.images || [],
  //           name: x['Nama Produk'],
  //           delivery: x.delivery || {},
  //           price: x['Harga Awal Produk'],
  //           locations: x['Nama Gudang'],
  //           variant_skuId: x['SKU'] || '',
  //           variant: x['Variant Produk'],
  //         };
  //         fixedData[index]?.items.push(newItem);
  //       }
  //     }
  //   }));
  //   setTransaction(fixedData)
  // }

  const fixedArray = (data) => {
    // data.images
    const dats = []
    const varDatas = []
    data.map((x,index) => {
      const array = x.images?.split(',')
      const array2 = x.categoryId?.split(',')
      const array3 = x.modules?.split(',')
      const array4 = x.variant_name?.split(',')
      const array5 = x.variant_image?.split('|')
      const array6 = x.stock?.split(',')
      const array7 = x.variant_description?.split(',')
      const array8 = x.variant_currency?.split(',')
      const array9 = x.variant_price?.split(',')
      const array10 = x.variant_warehouse?.split(',')
      const tabsData = {
        images: array,
        warehouseId: x.warehouse || '',
        name : x.name || '',
        price: x.price || '',
        price_high: x.price_high || '',
        price_high_int: parseInt(x.price_high) || '',
        price_low: x.price_low || '',
        price_low_int: parseInt(x.price) || '',
        price_int: parseInt(x.price) || '',
        type: x.type || '',
        categoryId: array2 || '',
        product_skuId: x.product_skuId || '',
        currency: x.currency || '',
        description: x.description || '',
        discount_type: x.discount_type || '',
        discount_amount: x.discount_amount || '',
        external_product_skuId: x.external_product_skuId || '',
        external_productId: x.external_productId || '',
        stocks: x.stocks || '',
        is_active: x.is_active === 1 ? true : false,
        is_promo : x.is_promo === 1 ? true : false,
        modules: array3,
        sold: 0,
        variant_name: array4 || '',
        variant_images: array5 || '',
        stock: array6 || '',
        // shipping: 'OExpress',
        variant_description: array7 || '',
        variant_currency: array8 || '',
        variant_price: array9 || '',
        variant_warehouse: array10 || '',
      }
      const variantDats = {
        name: array4 || '',
        images: array5 || '',
        stock: array6 || '',
        // shipping: 'OExpress',
        variant_description: array7 || '',
        variant_currency: array8 || '',
        variant_price: array9 || '',
        variant_warehouse: array10 || '',
      }

      dats.push(tabsData)
      varDatas.push(variantDats)
      console.log(variantDats,'aye')


    })
    // const variantData = varDatas.map((y,index) => {
    //   const data = {
    //     index: index,
    //     name: y.name || '',
    //     images: y.images || '',
    //     stock: y.stock || '',
    //     shipping: 'OExpress',
    //     variant_description: y.variant_description || '',
    //     variant_currency: y.variant_currency || '',
    //     variant_price: y.variant_price || '',
    //     variant_warehouse: y.variant_warehouse || '',            
    //   }
    //   return data
    // })
    console.log(dats)
    // console.log(variantData)
    setTransaction(dats)
  }
  //   console.log(file.target.files,'filessss')
  const onImport = () => {
    if (!file) {
      return toast({
        title: 'Error',
        description: 'Not Have Data',
        position: 'top-right',
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
    }

    if (file?.target?.files?.[0]?.name?.split('.').pop() !== 'xlsx') {
      return toast({
        title: 'Error',
        description: 'Invalid file type. Please select an XLSX file.',
        position: 'top-right',
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
    }
    const reader = new FileReader()

    reader.onload = (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: 'array' });
      const worksheet = workbook.Sheets[workbook.SheetNames[0]];
      const jsonData = XLSX.utils.sheet_to_json(worksheet, { raw: true });
      console.log(jsonData,'json')
      // setTransaction([...jsonData])
      fixedArray(jsonData)
    }

    reader.readAsArrayBuffer(file.target.files[0]);
  }

  const saveDocument = async () => {
    try {
      if (!transaction || transaction.length === 0) {
        return toast({
          title: 'Error',
          description: 'Not Have Data, plese input file  first.',
          position: 'top-right',
          status: 'error',
          duration: 5000,
          isClosable: true,
        });
      }
      const push = transaction.map(async(x) => {
        console.log(x)
        let totalStock = 0;
        for (let i = 0; i < x.stock.length; i++) {
          totalStock += parseInt(x.stock[i].trim());
        }

        const product = {
          companyId: globalState.currentCompany,
          projectId: globalState.currentProject,
          images: x.images,
          warehouseId: x.warehouseId || '',
          name : x.name || '',
          price: x.price.toString() || '',
          price_high: x.price_high.toString() || '',
          price_high_int: parseInt(x.price_high) || '',
          price_low: x.price_low.toString() || '',
          price_low_int: parseInt(x.price) || '',
          price_int: parseInt(x.price) || '',
          type: x.type || '',
          categoryId: x.categoryId || '',
          product_skuId: x.product_skuId || '',
          currency: x.currency || '',
          description: x.description || '',
          discount_type: x.discount_type || '',
          discount_amount: x.discount_amount || '',
          external_product_skuId: x.external_product_skuId || '',
          external_productId: x.external_productId || '',
          stocks: totalStock.toString() || '',
          stocks_int: parseInt(totalStock) || '',
          is_active: x.is_active === 1 ? true : false,
          is_promo : x.is_promo === 1 ? true : false,
          modules: x.modules || '',
          sold: 0,          
        }
        const idProduct = await addDocumentFirebase('product', product, globalState.currentCompany)        
        console.log(idProduct,'id')
        const variant = {
          // companyId: globalState.currentCompany,
          // projectId: globalState.currentProject,
          // productId: idProduct,
          name: x.variant_name || '',
          images: x.variant_images || '',
          stock: x.stock || '',
          type: x.type || '',
          // shipping: 'OExpress',
          description: x.variant_description || '',
          currency: x.variant_currency || '',
          price: x.variant_price || '',
          // price_int: array9 || '',
          warehouseId: x.variant_warehouse || '',
        }
        console.log(variant,'uhuy')
        if(!variant.name) {
          return ''
        }
        const newArray = (variant?.name || []).reduce((acc, curr, index) => {
          acc.push({
            images: (variant?.images && variant.images[index]) ? variant.images[index].split(',') : [],
            name: variant?.name ? variant.name[index] : '',
            stock: variant?.stock ? variant.stock[index] : '',
            description: variant?.description ? variant.description[index] : '',
            currency: variant?.currency ? variant.currency[index] : '',
            price: variant?.price ? variant.price[index] : '',
            price_int: variant?.price ? parseInt(variant.price[index]) : '',
            warehouseId: variant?.warehouseId ? variant.warehouseId[index] : '',
            shipping: 'OExpress',
            companyId: globalState.currentCompany || '',
            projectId: globalState.currentProject || '',
            productId: idProduct || '',
          });
          return acc;
        }, []);
        newArray.map(async(y) => {
          await addDocumentFirebase('product_variants', y, globalState.currentCompany)
        })
        console.log(newArray,'var')
      })
      // globalState.setIsLoading(true);
      // //   await addArrayDocumentFirebase(
      // //     'kpi',
      // //     transaction,
      // //   );
      // globalState.setIsLoading(false);
      // window.location.href = '/sopkpi/kpi-template';
      toast({
        title: 'Data saved to Firebase',
        status: 'success',
        duration: 3000,
        isClosable: true,
        position: 'top-right',
      });
    } catch (error) {
      console.error('Error saving data to Firebase:', error);
      toast({
        title: 'Error saving data to Firebase',
        description: error.message,
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
    }
  }

  const downloadTemplate = async () => {
    try {
      const spreadsheetUrl = 'https://docs.google.com/spreadsheets/d/1hGw4dzLoj418K7iCYzsNRqDdMuNrd9cRzESq6_XM_Ls/export?format=xlsx';
      const response = await axios.get(spreadsheetUrl, { responseType: 'blob' });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'template product.xlsx');
      document.body.appendChild(link);
      link.click();
    } catch (error) {
      console.error('Error downloading template:', error);
      // Handle error
    }
  };
  console.log(transaction)
  return (
    <>
      <Box>
        <HStack>
          <BackButtons />
          <Heading size={'md'}>Bulk Product</Heading>
          <Spacer />
        </HStack>

        <Box p="5" borderRadius="md" shadow="base" mt={5} textAlign="center">
          <CardFile onChange={onSelectFile} />

          <HStack mb={5} mt={5} justifyContent="center">
            <DynamicButton
              mt={5}
              mx={3}
              size={'sm'}
              color={'blue'}
              action="custom"
              title={'Load Document'}
              onClick={() => onImport()}
            />
            <DynamicButton
              mt={5}
              mx={3}
              size={'sm'}
              color={'blue'}
              action="custom"
              title={'Download Template'}
              onClick={downloadTemplate}
            />
          </HStack>

          <Stack alignItems={'end'} justifyContent="end" my={3}>
            <DynamicButton
              size={'sm'}
              action="create"
              title={'Save Document'}
              onClick={() => saveDocument()}
            />
          </Stack>

          <TableContainer
            border={'1px'}
            borderRadius={'sm'}
            borderColor={'gray.100'}
            boxShadow={'base'}
          >
            <Table variant="striped">
              <Thead>
                <Tr>
                  <Th>Images</Th>
                  <Th>Name </Th>
                  <Th>Price </Th>
                  <Th>SKU ID</Th>
                  <Th>Type</Th>
                  <Th>Category ID</Th>
                  <Th>Currency</Th>
                  <Th>Description</Th>
                  <Th>Discount Type</Th>
                  <Th>Discount Amount</Th>
                  <Th>External SKU ID </Th>
                  <Th>External ID</Th>
                  <Th>Stock</Th>
                </Tr>
              </Thead>
              <Tbody>
                {transaction?.map((x, i) => (
                  <Tr key={i}>
                    <Td> <Image src={x?.images[0]} /></Td>
                    <Td> {x?.name} </Td>
                    <Td> {x?.price} </Td>
                    <Td> {x?.product_skuId} </Td>
                    <Td> {x?.type} </Td>
                    <Td> 
                      <UnorderedList>
                        {x?.categoryId?.map((y) => (
                          <ListItem key={y}>{y}</ListItem>
                        ))}
                      </UnorderedList>
                    </Td>
                    <Td> {x?.currency} </Td>
                    <Td> {x?.description} </Td>
                    <Td> {x?.discount_type} </Td>
                    <Td> {x?.discount_amount} </Td>
                    <Td> {x?.external_product_skuId} </Td>
                    <Td> {x?.external_productId} </Td>
                    <Td> {x?.stocks} </Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
          </TableContainer>

        </Box>
      </Box>
    </>
  );
}

export default BulkProduct;